import * as http from 'utils/http';

const loading = () => ({
  type: 'LOAD_ROUTES_REQUEST',
});

const done = (enabled, disabled) => ({
  type: 'LOAD_ROUTES_DONE',
  enabled,
  disabled,
});

const cancel = (error) => ({
  type: 'LOAD_ROUTES_CANCEL',
  error,
});

export const fetchRoutes = () => {
  return (dispatch, getState, config) => {
    dispatch(loading());
    return Promise.all([
      http.get(config.API_URL + 'routes/?page_size=0&enabled=True'),
      http.get(config.API_URL + 'routes/?page_size=0&enabled=False'),
    ])
      .catch((err) => {
        dispatch(cancel(err));
        throw err;
      })
      .then(([enabled, disabled]) => dispatch(done(enabled, disabled)));
  };
};
